import PortfolioPageLayout from "../PortfolioPageLayout";
import phData from "./phData";

function PettesHounds() {
  return <PortfolioPageLayout {...phData} />;
}

export default PettesHounds;